import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms'
import { UserServices } from '../services/userservices.service'
import { NgProgress } from 'ngx-progressbar';
import { WebcamImage } from 'ngx-webcam';
@Component({
  selector: 'app-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.css']
})
export class PatientComponent implements OnInit {
  userProfileImage: string = "assets/img/user.png"
  userComparisonImage: string = "assets/img/user.png"
  userComparisonImageFile: any;
  ComparisonResult: any;
  patientDetails: any;
  profileForm: FormData;
  public webcamImage: WebcamImage;
  showWebCam: boolean = false;
  constructor(private userServices: UserServices, private ngProgress: NgProgress) { }

  ngOnInit() {
    debugger
    this.patientDetails = this.userServices.getPatientData()
    console.log(this.patientDetails)
    //this.userProfileImage = 'https://s3.amazonaws.com/sasadoctorimages/profileImages/03878b60-4b12-11e9-ab94-e305d8838097.JPG'
    this.userProfileImage = this.patientDetails.patientIdentityImagePath;
  }

  sendOtp() {
    console.log("i have been clicked")
  }

  verifyImage() {

    this.ComparisonResult = '';
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.userComparisonImageFile) {
      var form_data = new FormData();
      this.ngProgress.start();
      form_data.append('token', loginUser.token);
      //form_data.append('userid', '2c309c10-8b5e-11e8-a909-3d66d984b5cd');
      form_data.append('userid', this.patientDetails.patientId);
      form_data.append('orderId', this.patientDetails.orderId);
      form_data.append('profileImage', this.userProfileImage);
      form_data.append('image', this.userComparisonImageFile);
      this.userServices.varifyUser(form_data).subscribe(
        data => {
          if (data.returnCode == 0) {
            console.log('result')
            console.log(data)
            this.ComparisonResult = data.response;
            this.ngProgress.done();
          }
          else {
            alert(data.returnMsg)

          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });
    }
    else {
      alert("select image to verify user")
    }
  }


  getComparisonImage(imageInput: any, event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.userComparisonImageFile = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (e: any) => {
        // called once readAsDataURL is completed
        debugger
        this.userComparisonImage = e.target.result;
      }
    }
  }





  handleImage(webcamImage: WebcamImage) {
    debugger
    alert('webcamImage')
    if (webcamImage) {
      this.webcamImage = webcamImage;
      this.userComparisonImage = null
      this.userComparisonImage = webcamImage.imageAsDataUrl;
      this.convertImagetoFile(webcamImage.imageAsDataUrl)
    } 

  }

  convertImagetoFile(image: any) {

    let base64 = image.split('base64,')[1];
    //let base64 =  image;
    // // Naming the image
    // const date = new Date().valueOf();
    // let text = '';
    // const possibleText = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    // for (let i = 0; i < 5; i++) {
    //   text += possibleText.charAt(Math.floor(Math.random() * possibleText.length));
    // }
    // Replace extension according to your media type
    // const imageName = date + '.' + text + '.jpeg';
    const imageName = 'sasaimag' + '.jpeg';
    console.log('imageName')
    console.log(imageName)
    // call method that creates a blob from dataUri
    const imageBlob = this.dataURItoBlob(base64);
    const imageFile = new File([imageBlob], imageName, { type: 'image/jpeg' });
    console.log('imageFile')
    console.log(imageFile)
    this.userComparisonImageFile = imageFile;
  }
  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;

  }

  showWebCamPart() {
    if (this.showWebCam) {
      this.userComparisonImage = "assets/img/user.png"
      this.showWebCam=false;
    }
    else {
      this.userComparisonImage = "assets/img/user.png"
      this.showWebCam=true;
    }
  }

}
